import moment from "moment";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { CiFilter } from "react-icons/ci";
import { InputLabel, Popover } from "@mui/material";

import CustomDatePicker from "views/pages/manage/common/commonComponents/CustomDatePicker";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

import { getVendorFilterCount, vendorTypeOptions } from "../helper";
import {
  FILTERS_DEFAULT_STATE,
  PAYMENT_APPROVAL_STATUS_OPTIONS,
} from "./utils";

const PaymentApprovalFilters = ({
  onApply,
  onReset,
  buOptions = [],
  plantOptions = [],
  isLoading,
  filters,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterForm, setFilterForm] = useState(filters);

  const [filterCount, setFilterCount] = useState(0);

  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;

  useEffect(() => {
    setFilterForm(filters);
  }, [filters]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterFormHandler = (value, key) => {
    setFilterForm((prev) => ({ ...prev, [key]: value ?? null }));
  };

  const handleApply = () => {
    setAnchorEl(null);
    if (onApply) onApply(filterForm);

    const count = getVendorFilterCount(filterForm);
    setFilterCount(count);
  };

  const handleReset = () => {
    setFilterForm(FILTERS_DEFAULT_STATE);
    setFilterCount(0);
    if (onReset) onReset();

    setAnchorEl(null);
  };

  const isDisabled =
    !filterForm?.vendorType &&
    !filterForm?.bu?.length &&
    !filterForm?.status?.length &&
    !filterForm?.plantId?.length &&
    !filterForm?.approvalDateFrom &&
    !filterForm?.approvalDateTo;

  return (
    <>
      <AButton
        onClick={handleClick}
        aria-describedby={id}
        updatedStyle={
          filterCount > 0
            ? { border: "1px solid #00B0F5", color: "#00B0F5" }
            : {}
        }
        disabled={isLoading}
      >
        <CiFilter /> Filters {filterCount > 0 && `(${filterCount})`}
      </AButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Card
          className="mb-0 regular-body label-color"
          style={{ width: "330px", borderRadius: "12px" }}
        >
          <CardBody className="d-flex flex-column">
            <div className="text-bold text-lg mb-2">Filters</div>

            <AAutoComplete
              label="Vendor Type"
              items={vendorTypeOptions}
              currentValue={
                vendorTypeOptions.find(
                  (v) => v.value === filterForm.vendorType,
                ) || null
              }
              handleChange={(val) =>
                filterFormHandler(val?.value, "vendorType")
              }
              isMulti={false}
            />

            <AAutoComplete
              label="BU"
              items={buOptions}
              currentValue={buOptions.filter((v) =>
                (filterForm.bu || []).includes(v.value),
              )}
              handleChange={(vals) =>
                filterFormHandler(
                  vals.map((v) => v.value),
                  "bu",
                )
              }
              isMulti={true}
              isShowCount={true}
            />

            <AAutoComplete
              label="Plant Id"
              placeholder="Select"
              isMulti={true}
              isShowCount={true}
              items={plantOptions}
              currentValue={plantOptions.filter((v) =>
                (filterForm.plantId || []).includes(v.value),
              )}
              handleChange={(vals) =>
                filterFormHandler(
                  vals.map((v) => v.value),
                  "plantId",
                )
              }
              inputKey="plantId"
            />

            <AAutoComplete
              label="Status"
              items={PAYMENT_APPROVAL_STATUS_OPTIONS}
              currentValue={PAYMENT_APPROVAL_STATUS_OPTIONS.filter((v) =>
                (filterForm.status || []).includes(v.value),
              )}
              handleChange={(vals) =>
                filterFormHandler(
                  vals.map((v) => v.value),
                  "status",
                )
              }
              isMulti={true}
              isShowCount={true}
            />

            <div>
              <InputLabel
                style={{
                  fontSize: "12px",
                  marginTop: "8px",
                  marginBottom: "4px",
                }}
              >
                Approval date
              </InputLabel>
              <Row>
                <Col sm="6">
                  <CustomDatePicker
                    placeHolder="From"
                    value={
                      filterForm.approvalDateFrom
                        ? moment(filterForm.approvalDateFrom)
                        : null
                    }
                    handler={(index, date, keyName) =>
                      filterFormHandler(date, "approvalDateFrom")
                    }
                    maxDate={
                      filterForm.approvalDateTo
                        ? moment(filterForm.approvalDateTo)
                        : undefined
                    }
                  />
                </Col>
                <Col sm="6">
                  <CustomDatePicker
                    placeHolder="To"
                    value={
                      filterForm.approvalDateTo
                        ? moment(filterForm.approvalDateTo)
                        : null
                    }
                    handler={(index, date, keyName) =>
                      filterFormHandler(date, "approvalDateTo")
                    }
                    minDate={
                      filterForm.approvalDateFrom
                        ? moment(filterForm.approvalDateFrom)
                        : undefined
                    }
                  />
                </Col>
              </Row>
            </div>

            <div className="w-full d-flex justify-content-between flex-row-reverse mt-3">
              <AButton
                variant="primary_filled"
                onClick={handleApply}
                className="w-full"
                disabled={isDisabled}
              >
                Apply filter
              </AButton>
              {filterCount > 0 && (
                <AButton
                  variant="outline"
                  className="button_remove_left_margin"
                  updatedStyle={{
                    border: "1px solid #CC5F5F",
                    color: "#CC5F5F",
                  }}
                  onClick={handleReset}
                >
                  Reset
                </AButton>
              )}
            </div>
          </CardBody>
        </Card>
      </Popover>
    </>
  );
};

export default PaymentApprovalFilters;
